var Category = /** @class */ (function () {
    function Category(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        this.bg_description = obj.bg_description;
        this.en_description = obj.en_description;
        this.image_url = obj.image_url;
        this.parent_id = obj.parent_id;
        this.position = obj.position;
        this.slug = obj.slug;
        this.subcategories = obj.subcategories;
        this.home_visible = obj.home_visible;
        this.brand_hidden = obj.brand_hidden;
        this.header_hidden = obj.header_hidden;
        this.meta_title = obj.meta_title;
        this.meta_description = obj.meta_description;
    }
    Object.defineProperty(Category.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "BgDescription", {
        get: function () {
            return this.bg_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "EnDescription", {
        get: function () {
            return this.en_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "ImageUrl", {
        get: function () {
            return this.image_url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "ParentId", {
        get: function () {
            return this.parent_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "Slug", {
        get: function () {
            return this.slug;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "HomeVisible", {
        get: function () {
            return this.home_visible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "BrandHidden", {
        get: function () {
            return this.brand_hidden;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "MetaTitle", {
        get: function () {
            return this.meta_title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "MetaDescription", {
        get: function () {
            return this.meta_description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "HeaderHidden", {
        get: function () {
            return this.header_hidden;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "Subcategories", {
        get: function () {
            return this.subcategories;
        },
        set: function (subcategories) {
            this.subcategories = subcategories;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "key", {
        // for the data tree
        get: function () {
            // need the key for the context menu. All the items that come from the database will have keys.
            // therefore I don't mind to set the key to the name for those, that don't have an ID e.g. 
            // for those that are newly created. They won't have a context menu anyway
            return this.id ? this.id : this.en_name.replace(' ', '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "label", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "children", {
        get: function () {
            return this.subcategories;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Category.prototype, "icon", {
        // setting up a default icon
        get: function () {
            return 'fa fa-folder-open';
        },
        enumerable: false,
        configurable: true
    });
    return Category;
}());
export { Category };
export function createCategory(obj, id) {
    return new Category(obj, id);
}
export function createCategories(rawCategories) {
    var categories = [];
    var rawCategoriesData = rawCategories;
    for (var _i = 0, rawCategoriesData_1 = rawCategoriesData; _i < rawCategoriesData_1.length; _i++) {
        var rawCategory = rawCategoriesData_1[_i];
        var category = createCategory(rawCategory.attributes, rawCategory.id);
        if (category.Subcategories.length > 0) {
            // recursively adding the nested subcategories
            category.Subcategories = createCategories(category.Subcategories);
        }
        categories.push(category);
    }
    return categories;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/category/category.ts
// module id = 60
// module chunks = 0